<template>
  <div class="global-hold-or-not">
    <div v-if="value === HOLD" class="f-r-vc" style="gap: 2px;">
      <svg-icon icon-class="lock" class="svg-lock hold" />
      <el-tag type="warning" size="small">HOLD</el-tag>
    </div>
    <div v-else />
  </div>
</template>
<script>
import { HOLD, UNHOLD } from '@/core/models/constant'
export default {
  name: 'HoldOrNot',
  props: {
    value: {
      required: true
    }
  },
  data() {
    return {
      HOLD,
      UNHOLD
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
$color: $deep-danger;

.hold {
  filter: $svg-danger-color;
}

.el-tag {
  font-weight: bold;
  color: rgba($color, 0.7);
  background-color: rgba($color, 0.15);
}
</style>
